import React, { useCallback } from "react"
import { Col, Row } from "react-bootstrap"
import { State, useHookstate } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import { useLanguageState } from "../../globalStates/LanguageState"
import { getElementFieldValue, makeSetHandler, makeValidationHandler } from "../../globalStates/utils"
import Section from "../../components/Section"
import TextField from "../../components/Field/Text"
import ToggleSwitchField from "../../components/Field/ToggleSwitchField"
import { Organization, PrintCatalog } from "../../globalStates/ExhibitorDataTypes"

interface CompanyNameSectionProps {
    printCatalogState: State<PrintCatalog, Validation>
    organizationState: State<Organization, Validation>
    readOnly: boolean
}

const CompanyNameSection: React.FC<CompanyNameSectionProps> = ({ printCatalogState, organizationState, readOnly }) => {
    const branding = useLanguageState().getStrings()
    const printCatalog = useHookstate(printCatalogState)
    const onChangeNameImported = useCallback(() => {
        printCatalog.nameImported.set(!printCatalog.nameImported.get())
        if (printCatalog.nameImported.get()) {
            printCatalog.name.set(organizationState.name.get())
        }
    }, [organizationState.name, printCatalog.name, printCatalog.nameImported])

    return (
        <Section title={branding.configuration.printPage.sctCompanyName.lblSectionCompanyName}>
            <Row>
                <Col>
                    <ToggleSwitchField
                        name="copyCompanyName"
                        label={branding.configuration.printPage.lblCopyData}
                        value={printCatalog.nameImported.get()}
                        readonly={readOnly}
                        onChange={onChangeNameImported}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextField
                        id="companyName"
                        name="companyName"
                        label={branding.configuration.printPage.sctCompanyName.lblCompanyName}
                        placeholder={branding.configuration.printPage.sctCompanyName.hntCompanyName}
                        validate={makeValidationHandler(printCatalog, "name")}
                        value={getElementFieldValue(printCatalog, "name")}
                        onChange={makeSetHandler(printCatalog, "name")}
                        required
                        readonly={printCatalog.nameImported.get() || readOnly}
                        limit={255}
                    />
                </Col>
            </Row>
        </Section>
    )
}

export default CompanyNameSection
